/** Logged in as another extension from User Management (reseller); ExtensionShowLogout is set in localStorage. */
export const isExtensionImpersonationSession = () =>
  localStorage.getItem('ExtensionShowLogout') === 'true';
